export default {
  GET_DATA_DEFINITIONS_REQUEST: '@@data-definitions/GET_EDITOR_COMPONENTS_REQUEST',
  GET_DATA_DEFINITIONS_SUCCESS: '@@data-definitions/GET_EDITOR_COMPONENTS_SUCCESS',
  GET_DATA_DEFINITIONS_ERROR: '@@data-definitions/GET_EDITOR_COMPONENTS_ERROR',

  CREATE_DATA_DEFINITION_REQUEST: '@@data-definitions/CREATE_DATA_DEFINITION_REQUEST',
  CREATE_DATA_DEFINITION_SUCCESS: '@@data-definitions/CREATE_DATA_DEFINITION_SUCCESS',
  CREATE_DATA_DEFINITION_ERROR: '@@data-definitions/CREATE_DATA_DEFINITION_ERROR',

  UPDATE_DATA_DEFINITION_REQUEST: '@@data-definitions/UPDATE_DATA_DEFINITION_REQUEST',
  UPDATE_DATA_DEFINITION_SUCCESS: '@@data-definitions/UPDATE_DATA_DEFINITION_SUCCESS',
  UPDATE_DATA_DEFINITION_ERROR: '@@data-definitions/UPDATE_DATA_DEFINITION_ERROR',

  GET_INTERFACE_DATA_REQUEST: '@@data-definitions/GET_INTERFACE_DATA_REQUEST',
  GET_INTERFACE_DATA_SUCCESS: '@@data-definitions/GET_INTERFACE_DATA_SUCCESS',
  GET_INTERFACE_DATA_ERROR: '@@data-definitions/GET_INTERFACE_DATA_ERROR',

  GET_INPUT_DROPDOWN_DATA_DEFINITIONS_REQUEST: '@@data-definitions/GET_INPUT_DROPDOWN_DATA_DEFINITIONS_REQUEST',
  GET_INPUT_DROPDOWN_DATA_DEFINITIONS_SUCCESS: '@@data-definitions/GET_INPUT_DROPDOWN_DATA_DEFINITIONS_SUCCESS',
  GET_INPUT_DROPDOWN_DATA_DEFINITIONS_ERROR: '@@data-definitions/GET_INPUT_DROPDOWN_DATA_DEFINITIONS_ERROR',

  CHECK_LINK_LOSS_REQUEST: '@@data-definitions/CHECK_LINK_LOSS_REQUEST',
  CHECK_LINK_LOSS_SUCCESS: '@@data-definitions/CHECK_LINK_LOSS_SUCCESS',
  CHECK_LINK_LOSS_ERROR: '@@data-definitions/CHECK_LINK_LOSS_ERROR',
};
